import { render, staticRenderFns } from "./SelectProductsTable.vue?vue&type=template&id=d611de70&scoped=true&"
import script from "./SelectProductsTable.vue?vue&type=script&lang=js&"
export * from "./SelectProductsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d611de70",
  null
  
)

export default component.exports